import removeMultipleForwardSlashes from './removeMultipleForwardSlashes';

export default function prependBigramToPathname(
  bigram: string,
  pathname: string
) {
  const rawInterpolation = `/${bigram.toLowerCase()}/${pathname}`;
  return removeMultipleForwardSlashes(rawInterpolation);
}
